module.exports = __webpack_public_path__ + "img/rudn-skin.be2dc1a.jpg";